module.exports = __webpack_public_path__ + "img/direct email.f9f9e6c6.svg";